import { Box, ListItemText, Skeleton, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { PrintExportMenu } from "../PrintExportMenu"

const useStyles = makeStyles()((theme) => ({
    tile: {
        width: "12.5rem",
        padding: "1.25rem 1.5rem",
        borderRadius: "1.125rem",
        backgroundColor: theme.palette.common.white,
    },
    title: {
        color: theme.palette.tailwind.slate[400],
        fontWeight: theme.typography.fontWeightBold,
        letterSpacing: ".04em",
        lineHeight: 1.4,
        whiteSpace: "nowrap",
    },
    exportButton: {
        flexShrink: 0,
        width: "1.875rem",
        height: "1.875rem",
        borderRadius: ".625rem",
        fontSize: "1rem",
        color: theme.palette.tailwind.slate[600],
        backgroundColor: theme.palette.tailwind.slate[100],
        "&:hover, &[aria-expanded='true']": {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.tailwind.slate[900],
        },
    },
    count: {
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.tailwind.slate[900],
        lineHeight: 1,
    },
    unit: {
        color: theme.palette.tailwind.slate[400],
    },
    countSkeleton: {
        width: "3rem",
        height: "2.25rem",
    },
}))

type Props = Readonly<{
    count: number
    isLoading: boolean
    onPrint: () => void
    onExportCsv: () => void
}>

export function GuestsInHouseTile({ count, isLoading, onPrint, onExportCsv }: Props) {
    const { classes } = useStyles()

    return (
        <Box className={classes.tile}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" gap=".5rem">
                <LocalizedStrict id="service-center-reports-dashboard-guests-overview-in-house-title">
                    <Typography variant="overline" className={classes.title}>
                        Guests in house
                    </Typography>
                </LocalizedStrict>
                <PrintExportMenu
                    disabled={isLoading}
                    buttonClassName={classes.exportButton}
                    printLabel={
                        <LocalizedStrict id="service-center-reports-dashboard-guests-overview-print-guest-list">
                            <ListItemText>Print guest list</ListItemText>
                        </LocalizedStrict>
                    }
                    exportLabel={
                        <LocalizedStrict id="service-center-reports-dashboard-guests-overview-export-guest-list">
                            <ListItemText>Export to Excel</ListItemText>
                        </LocalizedStrict>
                    }
                    onPrint={onPrint}
                    onExportCsv={onExportCsv}
                />
            </Stack>
            <Stack direction="row" alignItems="baseline" gap=".5rem" marginTop="1.5rem">
                {isLoading ? (
                    <Skeleton variant="rounded" className={classes.countSkeleton} />
                ) : (
                    <Typography variant="h4" component="span" className={classes.count}>
                        {count}
                    </Typography>
                )}
                <LocalizedStrict id="service-center-reports-dashboard-guests-overview-in-house-unit">
                    <Typography variant="body1" component="span" className={classes.unit}>
                        in house
                    </Typography>
                </LocalizedStrict>
            </Stack>
        </Box>
    )
}
